import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableGameBuilds';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IGameBuildListOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlVersionDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class GameBuildListPage extends PageBase<IGameBuildListOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _filterVersions: JQuery;
    private _latestVersionsFilter: string;


    constructor(options: IGameBuildListOptions) {
        super(options);

        var getGameDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        var getGameBuildDetailUrl = (rowData: any): string => (`${options.urlVersionDetail}/${rowData.Id}/${rowData.VersionString}`);
        this.filterLatestVersions = this.filterLatestVersions.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this._latestVersionsFilter = null;

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: 'Name',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkName${rowData.Id}' href='${getGameDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "Code",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "Version",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkVersion${rowData.Id}' href='${getGameBuildDetailUrl(rowData)}'>${rowData.VersionString}</a>`)
                },
                {
                    data: "Status",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsValid",
                    render: (data: any, type: any, rowData: any) => {
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${StringUtils.capitalizeFirstLetter(data.toString())}</span>`;
                    }
                },
                {
                    data: "Description",
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDescription${rowData.Id}'>${data}</span>`)
                }
            ],
            callbacks: {
                drawCallback: () => {},
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._filterVersions = Utils.getJQueryById("filterVersionsCheckBox");
        this._filterVersions.change((data: any) => this.filterLatestVersions(data));
        this._latestVersionsFilter = (<HTMLInputElement>this._filterVersions[0]).checked.toString();
        this._table = new Datatable(tableId, this._tableOptions);
    }

    private filterLatestVersions(item: any) {
        this._latestVersionsFilter = item.target.checked;
        this._table.draw();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        datatable.search(this._latestVersionsFilter);

        return true;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Games/GameBuildList.ts
 **/